import { GET_ALL_MEMBERS_SUCCESS } from '../actions/actionTypes';

export default function allMembers(state = [], action) {
  switch (action.type) {
    case GET_ALL_MEMBERS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
